<div class="card">
  <div class="card-body">
    <div class="d-md-flex align-items-center bg-white p-3">
      <a href="javascript:void(0)" class="d-flex align-items-center p-2 rounded-pill bg-light" *ngIf="Lista">
        <h5 class="mb-0 mr-1 text-dark font-weight-bold font-14"> Totale</h5>
        <span class="badge badge-danger badge-pill px-3 font-weight-bold font-14">{{Lista.length}}</span>
      </a>
      <div class="ml-auto mt-3 mt-md-0">
        <button type="button" class="btn btn-cyan rounded-pill py-2" (click)='add()'><i
          class="fas fa-plus  font-14 mr-1 text-white"></i>
          <span class="ml-1 text-white font-weight-bold">Aggiungi</span>
        </button>
      </div>
    </div>
  </div>
</div>
<div class="card">
  <div class="card-body">
    <div class="table-responsive" style="height: 900px" >
      <table class="table bg-white table-hover align-middle mb-0 no-wrap">
        <thead>
        <tr>
          <th>Id</th>
          <th scope="col">Ruolo</th>
          <th scope="col">Capacità</th>
          <th scope="col">Azioni</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let item of Lista" >
          <td>
            <span *ngIf="item.id" class="text-dark font-medium font-16">{{ item.id }}</span>
          </td>
          <td class="align-middle" >
        <span *ngIf="!item.modifica">
          <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
            <i-feather name="Mail" class="feather-sm"></i-feather>
          </span>
          {{ item.ruolo }}
        </span>
            <span *ngIf="item.modifica">
              <input [(ngModel)]="item.ruolo" placeholder="Ruolo" type="text" name="ruolo" class="form-control">
        </span>
          </td>
          <td>
        <span *ngIf="item.modifica">
              <ng-multiselect-dropdown [settings]="dropdownSettings" [placeholder]="'Capacità'"  [data]="Capacita" [(ngModel)]="item.capacitaSelezionate" placement="top"></ng-multiselect-dropdown>
        </span>
          </td>
          <td class="align-middle" >
            <a *ngIf="!item.modifica"  href="javascript:void(0)" ngbTooltip="Modifica" class="link font-16 text-info font-medium mr-2"
               (click)='edit(item)'>
              <i-feather name="edit-3" class="feather-sm"></i-feather>
            </a>
            <a *ngIf="item.modifica" href="javascript:void(0)" ngbTooltip="Salva" class="link font-16 text-success font-medium mr-2" (click)='edit(item)'>
              <i-feather name="check" class="feather-sm"></i-feather>
            </a>
            <a *ngIf="!item.modifica" href="javascript:void(0)" ngbTooltip="Elimina"
               class="link font-16 text-danger font-weight-bold" (click)='delete(item)'>
              <i-feather name="trash-2" class="feather-sm"></i-feather>
            </a>
            <a *ngIf="item.modifica" href="javascript:void(0)" ngbTooltip="annulla"
               class="link font-16 text-danger font-weight-bold" (click)='delete(item)'>
              <i  class="fas fas fa-times"></i>
            </a>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

